import { css } from 'styled-system/css';


export const betslipHeaderStyle = {
	header: css({
		base: {
			py: '3px',
		},
		_mars: {
			borderColor: 'black.5',
			'& .quickbet-switch__thumb': {
				color: 'black.2',
			},
			'& .quickbet-switch:not([data-active=true]) .quickbet-switch__thumb--normal': {
				color: 'whiteOpacity.100',
			},
			'& .quickbet-switch:not([data-active=false]) .quickbet-switch__thumb--quick': {
				color: 'whiteOpacity.100',
			},
			'& .bet-slip__badge': {
				color: 'whiteOpacity.100',
			},
		},
	}),
	QuickBetHeaderFunds: css({
		base: {
			color: 'blackOpacity.54',
			fontSize: '12px',
		},
		_galaxy: {
			color: 'var(--text-utility-constant-black-80)',
		},
	}),
	headerBorder: css({
		_mars: {
			borderBottomWidth: 0,
			lg: {
				borderBottomWidth: '1px',
			}
		},
	}),
	betIcon: css({
		base: {
			color: 'brand.500',
			w: '27px',
			h: '27px'
		}
	}),
	stake: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			cursor: 'pointer',
			color: 'rgba(0, 0, 0, 70%)',
			h: '23px',
		}
	}),
	gearIcon: css({
		base: {
			w: '12px',
			h: '12px',
			_ltr: {
				ml: '3px',
			},
			_rtl: {
				mr: '3px',
			},
		}
	}),
	alertIcon: css({
		base: {
			color: 'var(--special-06)',
			w: '15px',
			h: '15px',
			animation: 'grow-shrink 500ms linear',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			bgColor: 'white',
			borderRadius: '28px',
			mx: '5px',
			'& .icon--ticket-exclamation': {
				transform: 'scale(2.0)',
			}
		},
		_mars: {
			color: '#F33333'
		}
	})
}